import { render, staticRenderFns } from "./BridgeInfo.vue?vue&type=template&id=1329ad5f&scoped=true&"
import script from "./BridgeInfo.vue?vue&type=script&lang=js&"
export * from "./BridgeInfo.vue?vue&type=script&lang=js&"
import style0 from "./BridgeInfo.vue?vue&type=style&index=0&id=1329ad5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329ad5f",
  null
  
)

export default component.exports